import React,{useEffect,useState,useContext} from 'react'
import "../App.css";
import firebase from "../base.js";
import { AuthContext } from "../Auth.js";
import Loading from "../Loading";
import moment from "moment";
import {useParams} from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import IconButton from '@mui/material/IconButton';
import BlogData from "./BlogData";

function StDesc() {


    const {id} = useParams();
    

  const [desc, set_desc] = useState({});
  const { currentUser } = useContext(AuthContext);

  console.log(currentUser);

  const [loading, setLoading] = useState(true);
  useEffect(() => {

    const subscriber = firebase.firestore()
      .collection("st_desc")
      .doc(id)
      .onSnapshot(data => {
        set_desc(data.data());
        setLoading(false);
      });
    return () => subscriber();
  }, []);
  return (

    <div className="dashboard">
         <div className='st_desc'>
        
        <div className='dashboard_head dash_row'>
				<h4>The Chartistt Bot</h4>

				<div className='dash_row'>
					
					<IconButton onClick={()=>firebase.auth().signOut()}>
						<LogoutIcon color="error" />
					</IconButton>
					
				</div>
			</div>

        </div>

        <BlogData blog_data={desc} id={id} user={currentUser}/>
       
    </div>
    
  )
}

export default StDesc